import type { Outcome } from './reviewTypes';
import type { CommandDeparture, CostBasis } from './types';

export function forecastText(text: string | null | undefined) {
  return text
    ?.replace(/\bP50\b/g, 'Main forecast')
    .replace(/\bP10\b/g, 'Lower forecast')
    .replace(/\bmain forecast\b/g, 'Main forecast')
    .replace(/\blower forecast\b/g, 'Lower forecast');
}

export function points(value: number | null | undefined) {
  if (value == null) return '—';
  const rounded = Number(value.toFixed(1));
  return `${rounded === 0 ? '0.0' : rounded.toFixed(1)}pp`;
}

export function outcomeScenario(outcome: Outcome, departure: CommandDeparture) {
  const booked = /booked/i.test(outcome.label);
  const forecast = /predicted/i.test(outcome.label);
  const total = booked
    ? departure.pax + 2
    : forecast
      ? departure.pred_pax == null
        ? null
        : departure.pred_pax + 2
      : departure.pred_pax == null || outcome.extra_travellers == null
        ? null
        : departure.pred_pax + outcome.extra_travellers;
  return {
    label: booked ? 'Booked + 2' : forecast ? 'Forecast + 2' : 'Needed to clear both minimums',
    travellers: total == null ? '—' : Math.round(total).toLocaleString('en-AU'),
  };
}

export function missingAssessmentInputs(departure: CommandDeparture, basis: CostBasis) {
  return [
    departure.adult_twin_price_now_aud == null && 'Current adult twin price missing',
    departure.pred_pax == null && 'Main forecast missing',
    departure.hedge_pax == null && 'Hedge traveller count missing',
    departure[`cost_${basis}`] == null && 'Supplier cost missing',
  ].filter((text): text is string => !!text);
}
